import {
    Delete,
    Edit,
    EyeOpen,
    NavigationChevronDown,
    NavigationChevronUp,
} from 'share-ui/components/Icon/Icons'
import styled from 'styled-components'

export const StyledEyeOpenIcon = styled(EyeOpen)`
    path {
        stroke: ${({ theme }) => theme.body.iconColor};
    }
`

export const StyledDeleteIcon = styled(Delete)`
    path {
        fill: ${({ theme }) => theme.body.iconColor};
    }
`

export const StyledEditIcon = styled(Edit)`
    path {
        fill: ${({ theme }) => theme.body.iconColor};
    }
`

export const StyledNavigationChevronUp = styled(NavigationChevronUp)`
    path {
        color: ${({ theme }) => theme.body.iconColor};
    }
`
export const StyledNavigationChevronDown = styled(NavigationChevronDown)`
    path {
        color: ${({ theme }) => theme.body.iconColor};
    }
`
